<template>
  <b-field label="ユーザータイプ">
    <b-radio
      v-for="option in userTypeOption"
      :key="option.value"
      v-model="userType"
      :native-value="option.value">
      {{option.display}}
    </b-radio>
  </b-field>

</template>

<script>

export default {
  name: 'UserTypeRadio',
  props: {
    value: String,
    userTypeOption: { // ユーザータイプの選択肢
      type: Array,
      default: function() {
        return [
          {
            value: 'performer',
            display: 'パフォーマー'
          },
          {
            value: 'patron',
            display: 'パトロン',
          },
        ]
      },
    },
  },
  computed: {
    userType: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    }
  },
}
</script>


<style lang="scss" scoped>
@import '../../assets/scss/profile-edit.scss';
</style>
